/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Full_Stack_Web_Apps_Cms_Title3Inputs */

const en_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headless CMS`)
};

const ar_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظام إدارة محتوى بلا واجهة`)
};

const bn_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হেডলেস CMS`)
};

const de_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headless CMS`)
};

const es_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CMS sin cabeza`)
};

const fr_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CMS sans tête`)
};

const pt_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CMS sem cabeça`)
};

const zh_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无头 CMS`)
};

const tr_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başsız CMS`)
};

const ru_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безголовая CMS`)
};

const pl_svc_full_stack_web_apps_cms_title3 = /** @type {(inputs: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezgłowy CMS`)
};

/**
* | output |
* | --- |
* | "Headless CMS" |
*
* @param {Svc_Full_Stack_Web_Apps_Cms_Title3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_full_stack_web_apps_cms_title3 = /** @type {((inputs?: Svc_Full_Stack_Web_Apps_Cms_Title3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Full_Stack_Web_Apps_Cms_Title3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "bn") return bn_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "de") return de_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "es") return es_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "fr") return fr_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "pt") return pt_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "zh") return zh_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "tr") return tr_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "ru") return ru_svc_full_stack_web_apps_cms_title3(inputs)
	if (locale === "pl") return pl_svc_full_stack_web_apps_cms_title3(inputs)
	return en_svc_full_stack_web_apps_cms_title3(inputs)
});
export { svc_full_stack_web_apps_cms_title3 as "svc_full-stack-web-apps_CMS_title" }